import { httpClient, ApiResponse } from '@/utils';
import { IManagersListResponse } from '@/models/admins.model';
import {
  IPartnersListResponse,
  ICreatePartnerDTO,
  IUpdatePartnerDTO,
  PartnersEndpoints,
  IPartnerProfileResponse,
  IPartnerAuthData,
  IGetPartnersListDTO,
} from '@/models/partners.model';
import convertModelToFormData from '../shared/utils/convertModelToFormData';

class PartnersAPI {
  static getPartnersList(data: IGetPartnersListDTO): ApiResponse<IPartnersListResponse> {
    return httpClient.get<IPartnersListResponse>(PartnersEndpoints.PARTNERS_LIST, { params: data });
  }

  static getPartnerDetails(id: string): ApiResponse<IPartnerProfileResponse> {
    return httpClient.get<IPartnerProfileResponse>(`${PartnersEndpoints.PARTNERS_LIST}/${id}`);
  }

  static deletePartner(id: string): ApiResponse<IPartnerProfileResponse> {
    return httpClient.delete<IPartnerProfileResponse>(`${PartnersEndpoints.PARTNERS_LIST}/${id}`);
  }

  static hidePartner(id: string): ApiResponse<IPartnerProfileResponse> {
    return httpClient.patch<IPartnerProfileResponse>(`${PartnersEndpoints.PARTNERS_LIST}/${id}/toggle-hidden`);
  }

  static togglePartnerActive(id: string): ApiResponse<IPartnerProfileResponse> {
    return httpClient.patch<IPartnerProfileResponse>(`${PartnersEndpoints.PARTNERS_LIST}/${id}/toggle-active`);
  }

  static updatePartnerDetails(data: IUpdatePartnerDTO): ApiResponse<IPartnerProfileResponse> {
    const formData = convertModelToFormData({ ...data });

    if (data.is_vat_payer !== undefined) {
      formData.set('is_vat_payer', data.is_vat_payer ? '1' : '0');
    }

    if (data.has_no_accountant !== undefined) {
      formData.set('has_no_accountant', data.has_no_accountant ? '1' : '0');
    }

    return httpClient.post<IPartnerProfileResponse>(`${PartnersEndpoints.PARTNERS_LIST}/${data.id}`, formData);
  }

  static createPartner(data: ICreatePartnerDTO): ApiResponse<IPartnerProfileResponse> {
    return httpClient.post<IPartnerProfileResponse>(PartnersEndpoints.PARTNERS_LIST, { ...data });
  }

  static getPartnerAuthData(id: string): ApiResponse<IPartnerAuthData> {
    return httpClient.get<IPartnerAuthData>(`${PartnersEndpoints.PARTNERS_LIST}/${id}/login-as`);
  }

  static resendInvitation(id: string): ApiResponse<void> {
    return httpClient.post<void>(`${PartnersEndpoints.PARTNERS_LIST}/${id}/resend-invitation`);
  }

  static getCategoryManagers(): ApiResponse<IManagersListResponse> {
    return httpClient.get<IManagersListResponse>(PartnersEndpoints.CATEGORY_MANAGERS);
  }
}

export default PartnersAPI;
